/* unplugin-vue-components disabled */import script from "./SmsSecret.vue?vue&type=script&setup=true&lang=js"
export * from "./SmsSecret.vue?vue&type=script&setup=true&lang=js"

import "./SmsSecret.vue?vue&type=style&index=0&id=b4d12f26&lang=scss&scoped=true"

import exportComponent from "D:\\igencloud_team\\ident-doc-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4d12f26"]])

export default __exports__